export {
  formatAud,
  formatPack,
  formatPerUnit,
  formatUnits,
  MAX_LINE_UNITS,
  MIN_ORDER_UNITS,
} from '@greengrocer/shared';

/** "13 Aug, 10:36 am" in the shop's own timezone, matching the server's rollups. */
const dateTime = new Intl.DateTimeFormat('en-AU', {
  timeZone: 'Australia/Broken_Hill',
  day: 'numeric',
  month: 'short',
  hour: 'numeric',
  minute: '2-digit',
});

const dayOnly = new Intl.DateTimeFormat('en-AU', {
  timeZone: 'Australia/Broken_Hill',
  weekday: 'short',
  day: 'numeric',
  month: 'short',
});

export function formatDateTime(value: string | Date): string {
  return dateTime.format(new Date(value));
}

export function formatDay(value: string | Date): string {
  // Date-only strings from Postgres have no timezone; parsing them as UTC noon
  // avoids the day sliding backwards under a positive offset like Broken Hill's.
  const date =
    typeof value === 'string' && value.length <= 10
      ? new Date(`${value}T12:00:00Z`)
      : new Date(value);
  return dayOnly.format(date);
}
